/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'
import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from '../../../components/Popover'

import MemoClose from '../Icons/Close'

import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'

import MemoFilter from '../Icons/Filter'
import { useTheme } from '../../../index'
import { useNotificationsHomeContext } from '../../context'
import { useBaseStyles } from '../../../hooks/styles/useBaseStyles'

export const LabelFilter = () => {
  const [hoveredItem, setHoveredItem] = useState(null)

  const { StyledMenuItem, filterButtonStyle } = useInAppNotificationStyles()

  const {
    data: { selectedLabel, labels },
    handlers: { setSelectedLabel }
  } = useNotificationsHomeContext()

  const { CustomFlexBox } = useBaseStyles()

  const theme = useTheme()

  useEffect(() => {
    if (labels?.length === 0) {
      setSelectedLabel('')
    }
  }, [labels?.length])

  const handleSetLabel = (e, label) => {
    e.stopPropagation()
    setSelectedLabel(label)
  }

  const handleClearSelectedLabel = (e) => {
    e.stopPropagation()
    setSelectedLabel('')
  }

  if (!labels || labels?.length === 0) {
    return <div></div>
  }

  return (
    <div onClick={(e) => e.stopPropagation()} role='menu'>
      <Popover>
        <PopoverTrigger asChild>
          <button
            style={{
              ...filterButtonStyle,
              position: 'relative'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            <MemoFilter
              sx={{
                color: theme.palette.text.secondary
              }}
            />

            {selectedLabel && (
              <div
                style={{
                  height: '10px',
                  width: '10px',
                  borderRadius: '50%',
                  background: theme.palette.primary.main,
                  position: 'absolute',
                  top: '5px',
                  right: 0
                }}
              />
            )}
          </button>
        </PopoverTrigger>

        <PopoverContent
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: theme.palette?.background?.paper || '#fff',
            borderRadius: '8px',
            padding: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 10000,
            minWidth: '150px'
          }}
          align='end'
          sideOffset={5}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {labels?.slice(0, 3)?.map((label) => {
              const isSelectedLabel = label === selectedLabel
              return (
                <StyledMenuItem
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    handleSetLabel(e, label)
                  }}
                  hoveredItem={hoveredItem}
                  type={label}
                  onMouseEnter={() => setHoveredItem(label)}
                  onMouseLeave={() => setHoveredItem(null)}
                  style={{
                    color: isSelectedLabel && theme.palette.primary.main
                  }}
                >
                  <CustomFlexBox
                    justifyContent='space-between'
                    alignItems='center'
                    style={{ width: '100%' }}
                  >
                    <span>{label}</span>
                    {isSelectedLabel && (
                      <div onClick={handleClearSelectedLabel}>
                        <MemoClose
                          sx={{
                            fontSize: '1rem',
                            height: '1rem',
                            width: '1ren',
                            verticalAlign: 'middle'
                          }}
                        />
                      </div>
                    )}
                  </CustomFlexBox>
                </StyledMenuItem>
              )
            })}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}
